import "/polyfills/nodelist-foreach";
import "/polyfills/closest";
import events from "/events";
import getLocale from "/utils/locale";
import loadScript from "/utils/load-script";
import assembleShareUrl from "/utils/assemble-share-url";
import { isChrome } from "/utils/user-agent";
import globals from "/utils/globals";

const loginQuery = "[data-action=facebook-login]";
const shareQuery = "[data-action=share-facebook]";
let isLoaded = false;

const loadFBScript = () => {
  const locale = getLocale();
  const url = `https://connect.facebook.net/${locale}_${locale.toUpperCase()}/sdk.js`;
  return loadScript(url)
    .then(() => {
      if (window.FB) {
        window.FB.init({
          appId: globals.facebookAppId,
          channelUrl: "/fb_channel",
          status: true,
          cookie: false,
          xfbml: true,
          version: "v4.0"
        });
      }
    })
    .catch(() => { /* ignored to reduce spam in airbrake */ });
};

const onLoginClick = trigger => {
  const form = trigger.closest("form");

  form.querySelectorAll("input[type=email],input[type=password]").forEach(node =>{
    node.value = "";
  });

  if (window.FB && window.FB.getLoginStatus) {
    window.FB.getLoginStatus(response => {

      const submitForm = (authResponse) => {
        form.querySelector(trigger.dataset.actionUrl).value = authResponse.accessToken;
        form.submit();
      };

      if (response.status === "connected") {
        submitForm(response.authResponse);
      } else {
        window.FB.login(response => {
          if (response.authResponse) {
            submitForm(response.authResponse);
          }
        }, { scope: "email" });
      }
    });
  } else {
    /* eslint-disable-next-line camelcase */
    window._blinkist_is_facebook_loaded = false;

    loadFBScript();
  }
};

const onShareClick = trigger => {
  events.track("body-20100417-share", "1-fb");

  let display = "iframe";
  let shareUrl;

  if (trigger.dataset.disableLinkSharing && trigger.getAttribute("href")) {
    shareUrl = assembleShareUrl(trigger.href);
  } else {
    shareUrl = assembleShareUrl("/");
  }

  if (isChrome()){
    display = "popup";
  }

  if (window.FB) {
    window.FB.ui(
      {
        method: "share",
        display: display,
        href: shareUrl
      },
      () => {}
    );
  }
};

const attachEvents = () => {
  const nodes = document.querySelectorAll(`${loginQuery},${shareQuery}`);
  nodes.forEach(node => node.removeAttribute("disabled"));

  // Ensure there no old listeners
  document.removeEventListener("click", onDocClick);

  // Add the new one
  document.addEventListener("click", onDocClick);
};

const onDocClick = e => {
  const loginTarget = e.target.closest(loginQuery);
  if (loginTarget) {
    e.preventDefault();
    onLoginClick(loginTarget);
    return;
  }

  const shareTarget = e.target.closest(shareQuery);
  if (shareTarget) {
    e.preventDefault();
    onShareClick(shareTarget);
    return;
  }
};

const initFacebookHandles = () => {

  const nodes = document.querySelectorAll(`${loginQuery},${shareQuery}`);

  if (nodes.length <= 0) {
    return;
  }

  nodes.forEach(node => node.setAttribute("disabled", "disabled"));

  if (!isLoaded) {
    isLoaded = true;
    loadFBScript()
      .then(attachEvents);
  }
};

// Listen to global event for reattaching the handlers
events.on("facebook:init", initFacebookHandles);

// Trigger the event initially on each page load
initFacebookHandles();
